import { Field, useFormikContext } from 'formik';
import React from "react";
import { useZipCodeValidation } from "utility/validation";
import LeafBox from 'components/atoms/LeafBox';
import ValidationIcon from "components/atoms/ValidationIcon";
import { useVersionLeafhome, useVersion } from "../../../hooks";

const ZipCodeInput = ({ fieldName, style = {}, boxStyle = {}, label = true }) => {
  const { errors, touched } = useFormikContext();
  const zipCodeValidation = useZipCodeValidation();
  const v2 = useVersion();
  const vLeafhome = useVersionLeafhome();

  const errorMessage = touched[fieldName] && errors[fieldName] ? errors[fieldName] : null;
  const inputId = `${fieldName}-input`;
  const errorId = `${fieldName}-error`;

  let inputStyle = vLeafhome
    ? {}
    : {
        width: '100%',
        borderRadius: '3px',
        height: '40px',
        border: '1px solid #d1d1d1',
        padding: '5px 10px',
      };

  inputStyle = {
    ...inputStyle,
    ...style,
  };

  return (
    <LeafBox style={boxStyle}>
      {label && (
        <label htmlFor={inputId}>
          {zipCodeValidation.zipCodeText}
          {v2 && <span className="required--asterisk text-danger"> * </span>}
        </label>
      )}

      <Field name={fieldName}>
        {({ field, form }) => {
          const handleZipChange = (e) => {
            let value = e.target.value.toUpperCase();

            form.setFieldValue(fieldName, value);
          };

          return (
            <>
              <input
                {...field}
                id={inputId}
                aria-describedby={errorMessage ? errorId : undefined}
                aria-invalid={!!errorMessage}
                className={`input-field ${
                  touched[fieldName] && errors[fieldName]
                    ? 'error'
                    : touched[fieldName]
                    ? 'correct'
                    : ''
                }`}
                onChange={handleZipChange}
                style={inputStyle}
                placeholder={zipCodeValidation.zipCodePlaceHolder}
              />
              {errorMessage && (
                <div id={errorId} className="visually-hidden" role="alert">
                  {errorMessage}
                </div>
              )}
            </>
          );
        }}
      </Field>

      <ValidationIcon fieldName={fieldName} touched={touched} errors={errors} />
    </LeafBox>
  );
};

export default ZipCodeInput;
